/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { setAuthData } from 'state/actions/session_status';
import { setFormEditableState, resetForm, receiveFormData } from '@insticator/insticator-ui';
import { updateUserInfoWithValidation } from 'state/actions/profile_status';
// component
import MyProfile from 'pages/dashboard/myprofile/myprofile';



/* ========== ~~~~~~~~~~ MY PROFILE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ profileStatus, sessionStatus }) => ({
    fields: profileStatus.personalInformationForm.fields,
    savingData: profileStatus.personalInformationForm.savingData,
    editable: profileStatus.personalInformationForm.editable,
    hasStoredData: Object.keys(profileStatus.personalInformationForm.storedData).length > 0,
    mocked: sessionStatus.mocked,
    userEmail: sessionStatus.userEmail,
    userFirstName: sessionStatus.userFirstName,
    userLastName: sessionStatus.userLastName,
    userPhoneNumber: sessionStatus.userPhoneNumber,
    userUUID: sessionStatus.userUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    updateUserInfoWithValidation: (fields, updatedFormData, userUUID, onSuccess, onFail) => dispatch(updateUserInfoWithValidation(fields, updatedFormData, userUUID, onSuccess, onFail)),
    resetForm: formName => dispatch(resetForm(formName)),
    receiveFormData: (formName, formData) => dispatch(receiveFormData(formName, formData)),
    setAuthData: data => dispatch(setAuthData(data))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyProfile);
